import { DataCard } from "components/common/DataCard";
import {
  CHOICES_TITLE,
  CIRH,
  CRH,
  RH_CHOICES_NOTE,
  RH_CIRH_CHOICES_TEXT1,
  RH_CIRH_CHOICES_TEXT2,
  RH_CRH_CHOICES_TEXT1,
  RH_CRH_CHOICES_TEXT2,
  RH_TEXT,
} from "./RequestRepaymentHoliday.const";

export const RHChoicesExplained = () => (
  <>
    <DataCard>
      <div className="choices-explained">
        <div className="zb-heading4 card-sub-heading">{RH_TEXT}</div>
        <div>
          <strong>{CHOICES_TITLE}</strong>
        </div>
        <div className="newline">
          <strong>{CRH}</strong>
        </div>
        <ul>
          <li>
            <span>{RH_CRH_CHOICES_TEXT1}</span>
          </li>
          <li>
            <span>{RH_CRH_CHOICES_TEXT2}</span>
          </li>
        </ul>
        <div>
          <strong>{CIRH}</strong>
        </div>
        <ul>
          <li>
            <span>{RH_CIRH_CHOICES_TEXT1}</span>
          </li>
          <li>
            <span>{RH_CIRH_CHOICES_TEXT2}</span>
          </li>
        </ul>
        <div className="selected-options-note">
          <strong>{RH_CHOICES_NOTE}</strong>
        </div>
      </div>
    </DataCard>
  </>
);
